<template>
	<div class="acreditacion-page" style="position: relative;">
		<div class="acreditacion-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div class="header-row" v-else>
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>{{ espectaculo.nombre }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="acreditacion-main">
			<div class="container">
				<div class="acreditacion-left" v-if="acreditacionValida">
					<!-- <img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/nacionalbusiness.jpg" alt="Nacional Business" width="100%" height="auto" style="margin-bottom: 20px;"> -->
					<h1>Acreditación</h1>
					<p>Completa los datos solicitados para solicitar tu acreditación.</p>
					<div class="acreditaciones">
						<div class="acreditacion">
							<div class="acreditacion-row">
								<span class="title">Datos personales</span>
							</div>
							<div class="acreditacion-row">
								<div class="input-group">
									<label for="ticket-nombre">Nombre</label>
									<input type="text" name="ticket-nombre" id="ticket-nombre" v-model="ticket.ticketNombre">
								</div>
								<div class="input-group">
									<label for="ticket-apellido">Apellido</label>
									<input type="text" name="ticket-apellido" id="ticket-apellido" v-model="ticket.ticketApellido">
								</div>
							</div>
							<div class="acreditacion-row">
								<div class="input-group">
									<label for="ticket-tipoDocumento">Tipo de documento</label>
									<multiselect name="tipoDocumento" id="ticket-tipoDocumento" v-model="ticket.ticketDocumentoTipo" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label for="ticket-documento">Documento</label>
									<input type="text" name="ticket-documento" id="ticket-documento" v-model="ticket.ticketDocumento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<div class="acreditacion-row">
								<div class="input-group">
									<label for="ticket-email">Correo electrónico</label>
									<input type="email" name="ticket-email" id="ticket-email" v-model="ticket.ticketEmail">
								</div>
								<div class="input-group">
									<label for="ticket-telefono">Teléfono</label>
									<input type="text" name="ticket-telefono" id="ticket-telefono" v-model="ticket.ticketTelefono" @keypress="soloNumeros">
								</div>
							</div>
							<div class="acreditacion-row">
								<div class="input-group">
									<label for="ticket-empresa">Empresa</label>
									<input type="empresa" name="ticket-empresa" id="ticket-empresa" v-model="ticket.ticketEmpresa">
								</div>
								<!-- <div class="input-group">
									<label for="ticket-cargo">Categoría (A o B)</label>
									<input type="text" name="ticket-cargo" id="ticket-cargo" v-model="ticket.ticketCargo">
								</div> -->
								<div class="input-group">
									<label for="ticket-cargo">Cargo</label>
									<input type="text" name="ticket-cargo" id="ticket-cargo" v-model="ticket.ticketCargo">
								</div>
							</div>
							<!-- <div class="acreditacion-row">
								<div class="input-group">
									<label for="ticket-empresa">Empresa</label>
									<input type="empresa" name="ticket-empresa" id="ticket-empresa" v-model="ticket.ticketEmpresa">
								</div>
								<div class="input-group">
									<label for="ticket-cargo">Cargo</label>
									<input type="text" name="ticket-cargo" id="ticket-cargo" v-model="ticket.ticketCargo">
								</div>
							</div> -->
							<div class="acreditacion-row">
								<span class="disclaimer-text">Asegurate de ingresar correctamente tu dirección de correo electrónico, ya que se te hará llegar el ticket a esa casilla.</span>
							</div>
						</div>
					</div>
					<div class="acreditacion-canjear">
						<button class="btn" @click="acreditarse()">Solicitar acreditación</button>
					</div>
				</div>
				<div class="acreditacion-left" v-else>
					<h1>¡Atención!</h1>
					<p>La acreditación para este espectáculo ya no se encuentra disponible</p>
				</div>
				<div class="acreditacion-right">
					<p>Información del espectáculo</p>
					<div class="acreditacion-right-content">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre">
								</div>
								<div class="ver-mapa" content="Ver ubicación" v-tippy="{ placement : 'bottom'}" v-if="espectaculo.escenarioMapaURL">
									<a :href="espectaculo.escenarioMapaURL" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal class="promptSolicitudExitosa" name="promptSolicitudExitosa" :clickToClose="false">
			<div class="solicitud-exitosa-content">
				<div class="solicitud-exitosa-header">
					<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
						<circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
						<path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
					</svg>
				</div>
				<div class="solicitud-exitosa-main">
					<span class="title">Solicitud realizada con éxito</span>
				</div>
				<div class="solicitud-exitosa-footer">
					<span>En caso de que tu solicitud sea aceptada, recibirás un correo electrónico con tu ticket. Si la misma es rechazada, se te notificará vía mail.</span>
				</div>
				<div class="solicitud-exitosa-boton">
					<a href="https://nacional.uy" class="btn">Volver</a>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon } from 'vue-feather-icons'

	export default {
		data(){
			return {
				acreditacionValida: true,
				espectaculo: {
					id: null,
					nombre: '',
					descripcion: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					escenarioDireccion: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					foto: null,
					requiereRepresentacionGrafica: true,
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false
				},
				ticket: {
					ticketNombre: '',
					ticketApellido: '',
					ticketDocumentoTipo: null,
					ticketDocumento: '',
					ticketTelefono: '',
					ticketEmail: '',
					ticketEmpresa: '',
					ticketCargo: ''
				},
				tipoDocumentoCI: null,
				tipoDocumentos: []
			}
		},
		components: {
			MapIcon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.tiposDocumento();
			await this.validarAcreditacion();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try{
					let response = await axios.post('/WSDocumentoTipoCortesiaPalco', {});
					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async validarAcreditacion(){
				// Valido acreditación
				try{
					let response = await axios.post('/WSAcreditacionGrlValidar', {	EspectaculoId: parseInt(this.$route.params.espectaculoId) }, {})

					if(response.data.ErrorCod === 0 || response.data.ErrorCod === 23){
						if(response.data.ErrorCod === 0){
							this.acreditacionValida = true;
						} else {
							this.acreditacionValida = false;
						}

						this.ticket.ticketDocumentoTipo = this.tipoDocumentoCI;
						
						let data = response.data.SDTEspectaculo;
						this.espectaculo.id = parseInt(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.espectaculo.tipoId = parseInt(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.requiereRepresentacionGrafica = data.EspectaculoRepresentacionGrafica;
						if (data.EspectaculoFotoURL.length > 0) {
							this.espectaculo.foto = data.EspectaculoFotoURL;
						} else {
							this.espectaculo.foto = process.env.VUE_IMG_BUCKET + 'parque-aereo.jpg';
						}
						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;
					} else {
						this.$router.push({ name: 'error' });
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async acreditarse(){
				this.$store.dispatch('cargando', true);
				let hayError = false;

				if(
					this.ticket.ticketNombre.trim() && 
					this.ticket.ticketApellido.trim() && 
					this.ticket.ticketDocumentoTipo && 
					this.ticket.ticketDocumento.trim() && 
					this.ticket.ticketTelefono.trim() && 
					this.ticket.ticketEmail.trim()
					//  && 
					// this.ticket.ticketEmpresa.trim() &&
					// this.ticket.ticketCargo.trim()
				){
					if(this.ticket.ticketTelefono.length < 8 || this.ticket.ticketTelefono.length > 20){
						hayError = true
						this.$store.dispatch('mostrarError', 'Teléfono incorrecto')
						this.$store.dispatch('cargando', false);
					}
				} else {
					hayError = true
					this.$store.dispatch('mostrarError', 'Debes ingresar todos los datos para la acreditación')
					this.$store.dispatch('cargando', false);
				}

				if(hayError === false){
					let SDTAcreditacionGrl = {
						AcreditacionGrlId: 0,
						AcreditacionGrlNombre: this.ticket.ticketNombre.trim(),
						AcreditacionGrlApellido: this.ticket.ticketApellido.trim(),
						AcreditacionGrlDocumentoTipoId: parseInt(this.ticket.ticketDocumentoTipo.valor),
						AcreditacionGrlDocumento: this.ticket.ticketDocumento.trim(),
						AcreditacionGrlEmail: this.ticket.ticketEmail.trim(),
						AcreditacionGrlTelefono: this.ticket.ticketTelefono.trim(),
						AcreditacionGrlEmpresa: this.ticket.ticketEmpresa.trim(),
						AcreditacionGrlCargo: this.ticket.ticketCargo.trim()
					}

					try {
						let response = await axios.post('/WSAcreditacionGrlSolicitud', { EspectaculoId: parseInt(this.$route.params.espectaculoId), SDTAcreditacionGrl: SDTAcreditacionGrl })

						if(response.data.ErrorCod === 0){
							this.$modal.show('promptSolicitudExitosa');
							this.$store.dispatch('cargando', false);
						} else {
							if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
								this.$store.dispatch('cargando', false);
								this.$store.dispatch('mostrarError', 'Ocurrió un error')
								this.$router.push({ name: 'error' });
							} else {
								this.$store.dispatch('cargando', false);
								this.$store.dispatch('mostrarError', response.data.ErrorDsc)
							}
						}
					} catch (error) {
						this.$store.dispatch('mostrarError', 'Ocurrió un error')
						this.$store.dispatch('cargando', false);
					}
				}

				this.$store.dispatch('cargando', false);
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	// Multiselects
	.multiselect {
		min-height: 44px;
		width: 100%;
		cursor: pointer;
		transition: all 0.2s;

		&:hover .multiselect__tags {
			transition: all 0.2s;
			border-color: var(--color-blue);
		}
	}

	.multiselect__input,
	.multiselect__single {
		margin: 0;
		font-size: 16px;
		line-height: 25px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-left: 0;
	}

	.multiselect__tags {
		border-radius: 0px;
		font-size: 16px;
		line-height: 25px;
		border: none;
		border-bottom: 1px solid var(--color-grey-light);
		display: block;
		width: 100%;
		height: 100%;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-top: 8px;
		padding-bottom: 10px;
		padding-left: 0px;
		padding-right: 40px;
		outline: none;
		background-color: var(--color-white);
	}

	.multiselect__option--highlight {
		background-color: var(--color-grey-lighter);
		color: var(--color-black);
	}

	.multiselect__option--selected.multiselect__option--highlight {
		background-color: var(--color-red);
		// border-left: 2px solid var(--color-blue-dark);
		color: var(--color-white);
	}

	.multiselect__option {
		font-size: 13px;
		line-height: 13px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
	}

	.multiselect__option--selected {
		background-color: var(--color-blue);
		color: var(--color-white);
		font-size: 13px;
		line-height: 13px;
	}

	.multiselect__option--highlight:after {
		background: transparent;
		color: #999;
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__option--selected.multiselect__option--highlight:after,
	.multiselect__option--selected:after {
		background: transparent;
		color: var(--color-white);
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__tag {
		margin-bottom: 3px !important;
		margin-right: 8px !important;
		background: var(--color-blue) !important;
	}

	.multiselect__tag-icon:after {
		color: var(--color-white) !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		background: none !important;
	}

	.multiselect__placeholder {
		padding-top: 0px;
		margin-bottom: 0px;
	}

	@media screen and(max-width: 590px){
		.multiselect__input, .multiselect__single{
			font-size: 14px !important;
		}

		.multiselect__tags{
			padding-top: 10px;
			padding-bottom: 6px;
			padding-right: 30px;
		}
	}
</style>

<style lang="scss" scoped>
	.acreditacion-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.acreditacion-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 310px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);

				max-width: 1166px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: #fff;
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{

							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.acreditacion-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.acreditacion-right{
					top: 102px;
					position: sticky;
					margin-top: 41px;
					width: calc(33.33% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.acreditacion-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.competencia{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(row, space-between, center);

							.competencia-info{
								@include flex(column, center, flex-start);

								span.competencia-nombre{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								span.competencia-instancia{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}

							img{
								height: 32px;
								width: auto;
								margin-left: 15px;
							}
						}

						.fecha{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.fecha-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.fecha-content{
								width: 100%;
								@include flex(row, space-between, center);

								.fecha-texto{
									@include flex(column, center, flex-start);

									p{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
										margin: 0;
									}
								}

								.fecha-hora{
									height: 100%;
									margin-left: 14px;
									border-left: 1px solid #d3d3dc;
									padding: 10px 0 10px 14px;
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 21px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}
						}

						.lugar{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.lugar-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.lugar-content{
								@include flex(row, space-between, center);
								width: 100%;

								.lugar-content-left{
									@include flex(row, flex-start, center);

									.lugar-info{
										padding-right: 12px;
										// border-right: 1px solid #d3d3dc;
										@include flex(column, center, flex-start);

										span.lugar-escenario{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 15px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 20px;
										}

										span.lugar-direccion{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 13px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 18px;
										}
									}

									img{
										width: 28px;
										height: auto;
										margin-left: 12px;
									}
								}

								.ver-mapa{
									@include flex(column, center, center);
									margin-left: 12px;

									a{
										background-color: transparent;
										border: 1px solid var(--color-blue-darker);
										padding: 6px;
										text-decoration: none;
										@include flex(row, center, center);
										transition: all .2s;
										border-radius: 99px;

										svg{
											width: 15px;
											height: auto;
											transition: all .2s;
											color: var(--color-blue-darker);
										}

										&:hover{
											background-color: var(--color-blue-darker);

											svg{
												color: var(--color-white);
											}
										}
									}
								}
							}
						}

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.descripcion-content{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}
				}

				.acreditacion-left{
					width: calc(66.66% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.acreditaciones{
						width: 100%;
						margin-top: 20px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						// grid-auto-rows: 1fr;
						// grid-column-gap: 20px;
						grid-row-gap: 25px;

						.acreditacion{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							@include flex(column, flex-start, flex-start);
							transition: all .2s;

							&:after{
								content: 'ACREDITACIÓN';
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: 100%;
								@include flex(row, center, center);
								color: var(--color-red);
								writing-mode:vertical-lr;
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								font-weight: 700;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								border-right: 8px solid var(--color-blue);
								border-left: 8px solid var(--color-blue);
								background-color: var(--color-white);
							}

							.acreditacion-row{
								width: 100%;
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
									padding: 0px 8px 12px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									label{
										font-size: 16px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 19px;
										font-family: var(--font-family-fira);
									}

									input{
										font-size: 16px;
										line-height: 25px;
										padding-top: 8px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 8px;
										padding-bottom: 10px;

										&:focus{
											border-color: var(--color-blue);
										}
									}
								}

								.disclaimer-text{
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-grey);
									font-family: var(--font-family-fira);
									font-size: 12px;
									line-height: 1.4em;
									padding: 0px;
								}

								&.row-complemento{
									flex-wrap: wrap;

									.input-group{
										width: 50%;
										padding-bottom: 15px;

										&:nth-child(2n){
											padding-right: 0px;
										}

										&:nth-child(2n + 1){
											padding-left: 0px;
										}
									}
								}
							}

							span.title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 10px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}
						}
					}

					.acreditacion-canjear{
						button.btn{
							width: 100%;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							width: 100%;
							background-color: var(--color-red);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							min-height: 48px;
							padding: 0 24px;
							font-size: 16px;
							line-height: 25px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;
							margin-top: 32px;

							&:hover{
								background-color: var(--color-blue-dark);
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.acreditacion-page{
			.acreditacion-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.acreditacion-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.acreditacion-left{
						width: 100%;
					}

					.acreditacion-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.acreditacion-page{
			.acreditacion-main{
				.container{
					.acreditacion-left{
						.acreditaciones{
							.acreditacion{
								padding-left: 60px;

								.acreditacion-row{
									.input-group{
										label{
											font-size: 14px;
											line-height: 17px;
										}

										input{
											font-size: 14px;
											line-height: 20px;
										}
									}

									&.row-complemento{
										.input-group{
											width: 100%;
										}
									}
								}

								&:after{
									width: 40px;
									height: calc(100% - 40px);
								}

								&:before{
									width: 40px;
									height: 40px;
									font-size: 13px;
								}
							}
						}
						.acreditacion-canjear button.btn{
							min-height: 40px;
							margin-top: 20px;
							font-size: 14px;
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 510px){
		.acreditacion-page{
			.acreditacion-main{
				.container{
					.acreditacion-left{
						.acreditaciones{
							.acreditacion{
								.acreditacion-row{
									@include flex(column, flex-start, flex-start);

									.input-group{
										width: 100%;
										padding: 0px;
										padding-bottom: 5px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.acreditacion-page{
			.acreditacion-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}
</style>